import AboutConnection from 'sharedreact/connections/AboutConnection';
import AboutConstants from 'sharedreact/constants/AboutConstants';
import type ErrorData from 'sharedreact/data/ErrorData';
import Version from 'sharedreact/data/Version';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

// private functions
function _onFetchSuccess (version: Version): void {
  AppDispatcher.dispatch({
    actionType: AboutConstants.GET_SUCCESS,
    item: version,
    logLevel: 'trace'
  });
}

function _onFetchFailure (error: ErrorData): void {
  AppDispatcher.dispatch({
    actionType: AboutConstants.GET_FAIL,
    error: error,
    logLevel: 'error'
  });
}

function _onGetLegalNoticesSuccess (legalNotices: string): void {
  AppDispatcher.dispatch({
    actionType: AboutConstants.GET_LEGAL_NOTICES_SUCCESS,
    legalNotices: legalNotices,
    logLevel: 'trace'
  });
}

function _onGetLegalNoticesFailure (error: ErrorData): void {
  AppDispatcher.dispatch({
    actionType: AboutConstants.GET_LEGAL_NOTICES_FAIL,
    error: error,
    logLevel: 'error'
  });
}

// exported functions
function fetch (): void {
  AboutConnection.fetch(_onFetchSuccess, _onFetchFailure);
}

function getLegalNotices (): void {
  AboutConnection.getLegalNotices(_onGetLegalNoticesSuccess, _onGetLegalNoticesFailure);
}

function showAbout (): void {
  AppDispatcher.dispatch({
    actionType: AboutConstants.SHOW_ABOUT,
    logLevel: 'trace'
  });
}

function hideAbout (): void {
  AppDispatcher.dispatch({
    actionType: AboutConstants.HIDE_ABOUT,
    logLevel: 'trace'
  });
}

export default {
  fetch,
  getLegalNotices,
  showAbout,
  hideAbout
};
